<template>
  <main>
    <v-container>
      <ParentInfoForm />
    </v-container>
  </main>
</template>

<script>
export default {
  data() {
    return {
      search: null
    };
  },
  components: {
    ParentInfoForm: () => import("./components/Form")
  }
};
</script>
